import type { MultiSelectOption, MultiSelectProps } from '@hotjar/hotsauce';
import { DEFAULT_LABEL_ICONS } from '../constants/label-icons';
import type { Label as LabelModel } from '../domains/model';

type MultiSelectOptions = MultiSelectProps['availableOptions'];

export const mapLabelsToMultiSelectOptions = (labels?: Array<LabelModel>): MultiSelectOptions => {
  return (
    labels?.map(
      (label) =>
        ({
          label: label.name,
          value: label.id,
          icon:
            label.iconName !== 'unknown'
              ? DEFAULT_LABEL_ICONS[label.iconName] ?? label.iconName
              : undefined,
        } as MultiSelectOption),
    ) ?? []
  );
};
